import { Component, OnInit, AfterViewInit, OnDestroy, inject} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CommonService, ModalWrapperService, UserService } from "./services";
import { PreviousRouteService } from "./services/previous-route.service";
import { HubService } from "./services/Hub.service";
import { Location } from "@angular/common";
import { StorageService } from "./services/storage.service";
import { CommonStore } from "./store";
import * as moment from "moment";
import { BehaviorSubject, Subject, fromEvent, merge, timer} from "rxjs";
import { PrivMaskGuard } from "./guards";
import { CommonWarnorconfirmPopupComponent } from "./modules/shared/common-warnorconfirm-popup/common-warnorconfirm-popup.component";
import { filter, take, takeUntil } from "rxjs/operators";
import { NavigationStart, Router } from "@angular/router";
import { InterfaceUtils } from "./utils/interface.util";
import { appState } from "./store/appstate";
import { CommonUtil } from "./utils/common.util";
import { LicenseKeysBootstrapService } from "./services";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    elem: any;
    HTTPActivity: boolean;
    
    hubSubscription: any;
    testType: string;
    payload: string;
    // endTime: string;
    endTime: number;
    stopTimeset: boolean;
    timer: number;
    settingsTimer: number;
    wijimoDistKey: any;
    accountSettingsTabPrivs: any = [];
    accountSettings: any  = {};
    checkd: boolean;
    unsubscribe$: Subject<void> = new Subject();
    _interfaceUtil = inject(InterfaceUtils);
    private retryCount = 0;
    private maxRetries = 5;
    private lastActiveSubject = new BehaviorSubject<Date>(new Date());
    private licenseKeysBootstrapService = inject(LicenseKeysBootstrapService);

    constructor(
        private translate: TranslateService,
        private routingState: PreviousRouteService,
        private userService: UserService,
        private hubservice: HubService,
        private _commonSer: CommonService,
        private _location: Location,
        private _commonStore: CommonStore,
        private _prvMskGrd: PrivMaskGuard, private _modalService: ModalWrapperService,
        private _router: Router,
        private _commonUtil: CommonUtil,
        private _storageService: StorageService
    ) {
        if (!this._commonSer.secretphrase && localStorage.getItem("secretPhase")) {
            this._commonSer.secretphrase = localStorage.getItem("secretPhase");
        }
        translate.setDefaultLang("en");
        // this.translate.use("fr"); // we need to get from localstorage
        // routingState.loadRouting();
    }

    ngOnInit() {
        this.hubservice.connect();
        this.hubSubscription = this.hubservice.
        messageHubClass.subscribe(loc => {
        });
        let value;
        value = this._commonUtil.commonLocationPath();
        if (typeof localStorage !== 'undefined' && localStorage.getItem("userLogged") && (value && !value.includes('/login'))) {
            this.getWijimoAndDWTDWTLicenseKey();
        }
        this._router.events.pipe(filter(event => event instanceof NavigationStart),take(1)).subscribe(event => {
            if (value && !value.includes("/login")) {
                delete appState['isSessionValid'];
            }
        });
    }
    
   
    getWijimoAndDWTDWTLicenseKey() {
        this.userService.getWijimoAndDWTDWTLicenseKey().subscribe({
            next:(resp) => {
                if (resp) {
                this.retryCount = 0;
                void this.licenseKeysBootstrapService.apply(resp);
                }
             }, error:(err) => {
                if ((err.status === 403 || err.status === 401) && this.retryCount < this.maxRetries) {
                    console.warn('403 fetching license key, retrying...' + this.retryCount);
                    this.retryCount++;
                        timer(500).subscribe(() => {
                            this.getWijimoAndDWTDWTLicenseKey();
                        });
                    } else {
                    console.error('Error fetching license key:', err);
                }
            }
        });
    }
    ngAfterViewInit() {
        let value;
        value = this._commonUtil.commonLocationPath();
        // const value = window.location.href;
        if (value && !value.includes("/login")) {
            const scrollEvents$    = fromEvent(window, "mousewheel");
            const KeyEvents$     = fromEvent(window, "keyup");
            const MouseClickEvents$     = fromEvent(window, "click");
            const MouseMoveEvents$ = fromEvent(window, "mousemove");
            const allEvents$ = merge(
            scrollEvents$,
            KeyEvents$,
            MouseClickEvents$,
            MouseMoveEvents$
            );
            allEvents$.pipe(takeUntil(this.unsubscribe$))
            .subscribe((event) => {
                // const value = this._location.path();
                const value = !localStorage.getItem("userLogged")? this._location.path() : window.location.href;
                const noEvent = localStorage.getItem("NOEVENT") ? this._commonSer.DecryptData(localStorage.getItem("NOEVENT")) : null;
                const sessionExpPopupExists = sessionStorage.getItem("TimeOutPopOpened") ? this._commonSer.DecryptData(sessionStorage.getItem("TimeOutPopOpened")) : null;
                if(event && noEvent !== "true" && sessionExpPopupExists !== "true" && !this.userService.getAccessToken() && !localStorage.getItem("userLogged") && value && (!value.includes("/login") && !value.includes("redirectsso")) && !this.checkd && localStorage.getItem("TimeOutSession") !== "true") {
                    this.checkd = true;
                    //This popup comes only for multiple tabs
                    const modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
                            backdrop: false,
                            keyboard: false, windowClass: "large--content session-timeout-popup"
                        });
                        modelRef.componentInstance.warnMsg = "Session has timed out. Please login to continue."
                        modelRef.componentInstance.okButton = true;
                        modelRef.componentInstance.IsPopUpClosed.subscribe((resp: any) => {
                            modelRef.close();
                            this._commonStore.isTimeOutSession(null);
                            sessionStorage.removeItem("TimeOutPopOpened");
                            this.clearCookies(true);
                            // window.close();   
                            // this.canCloseWindow.emit(true);
                            // window.onbeforeunload = null;
                            // sessionStorage.removeItem("Timeout");
                        });
                } else if (event && noEvent !== "true") {
                    this.increaseTimeOut(value);
                    this.checkAndSetInactiveTimestamp();
                    if (localStorage.getItem("TimeOutSession") === "true") {
                        localStorage.removeItem("TimeOutSession");
                    }
                } else if (localStorage.getItem("TimeOutSession") === "true") {
                    localStorage.removeItem("TimeOutSession");
                }
            });
        }
    // }
      }
      clearCookies(timeExpired?: boolean) {
        const res = document.cookie;
        const multiple = res.split(";");
        for (let i = 0; i < multiple.length; i++) {
            const key = multiple[i].split("=");
            document.cookie =
                "" +
                key[0] +
                "=; expires= Thu, 21 Aug 1970 20:00:00 UTC; path=/ ";
        }
        let SfaxEncryptionVector = this._commonSer.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
        let printSet = localStorage.getItem("DefaultLabelPrinter");
        let reportPrint = localStorage.getItem("DefaultReportPrinter");
        let IsImmediateModeKey = localStorage.getItem("ImmediateOrPopMode") ? this._commonSer.getDecryptLocalStorage("ImmediateOrPopMode",false,SfaxEncryptionVector): null;
        let EyeconIP = localStorage.getItem("EyeconIP") ? this._commonSer.getDecryptLocalStorage("EyeconIP",false,SfaxEncryptionVector) : null;
        let guidKey = localStorage.getItem("GUIDEyecon") ? this._commonSer.getDecryptLocalStorage("GUIDEyecon",false,SfaxEncryptionVector): null;
        let popModeAssigned = localStorage.getItem("popModeAssigned") ? this._commonSer.getDecryptLocalStorage("popModeAssigned",false,SfaxEncryptionVector): null;
        let sso = this._commonSer.DecryptData(localStorage.getItem("SSO"));
        let redirectUrl = localStorage.getItem("redirectUrl");
        const storedValue = this._storageService.get("IvrGUIDDetails");
        let ivrGuid = this._commonSer.getIvrGUIDDetails(storedValue, SfaxEncryptionVector);
        localStorage.clear();
        if (printSet) {
            localStorage.setItem("DefaultLabelPrinter", printSet);
        }
        if (reportPrint) {
            localStorage.setItem("DefaultReportPrinter", reportPrint);
        }
        this._interfaceUtil.setPillCounterLocalStorage(SfaxEncryptionVector, IsImmediateModeKey, guidKey, EyeconIP, popModeAssigned);
        if(ivrGuid) {
            this._storageService.set("IvrGUIDDetails", ivrGuid);
        }
        sessionStorage.clear();
        if (timeExpired) {
            localStorage.setItem("TimeOutSession", "true");
        }
        if(!sso)
        {
            window.close();
            window.close();
        }
        else
        {
            if(redirectUrl){
                window.close();
                window.onbeforeunload = null;
                window.location.href = redirectUrl;
            } else{
                this._router.navigate(["/login"]);
            }
        }
    }
    increaseTimeOut(value) {
        this._commonSer.systemSettings$.subscribe(resp => {
            if (resp) {
                this.endTime = this._commonSer.getSetttingValue(
                    "PharmacySettings",
                    "IN_ACTIVITY_TIMEOUT"
                );
                // localStorage.removeItem("TimeOut");
            }
        });
        if (!this.endTime) {
            this.endTime = this._commonSer.DecryptData(localStorage.getItem("TimeOut"));
        }
        if(value && (!value.includes("/login") && !value.includes("redirectsso")) && (!sessionStorage.getItem("ExpireTime") || (sessionStorage.getItem("ExpireTime") && !this._commonSer.DecryptData(sessionStorage.getItem("ExpireTime"))))) {
            this.userService.notifyIdleTimedOut("logout");
        } else {
            sessionStorage.setItem("ExpireTime", this._commonSer.encryptData(moment().add(this.endTime * 60, 'seconds').toISOString()));
        }
    }
    
    checkAndSetInactiveTimestamp () {
        const currentActiveSessionTime = appState.activeSessionTimeStamp || new Date();
        const now = new Date();
        const timeDiff = now.getTime() - new Date(currentActiveSessionTime).getTime();
        if (timeDiff && timeDiff > 60000*10) {
            delete appState["isSessionValid"];
        }
        appState.activeSessionTimeStamp = new Date();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
